import {
	Card,
	HStack,
	Stack,
	Text,
} from '@chakra-ui/react';

import { NextImageWithSkeleton } from '@packages/chakra-v3';
import React from 'react';
import { useTranslations } from 'next-intl';

type CartSummaryCardProps = {
	children: React.ReactNode;
};

const CartSummaryCard = ({ children }: CartSummaryCardProps) => {
	const t = useTranslations('CartPage.cartSummary');

	return (
		<Card.Root p={2}>
			<Card.Header>
				<Text textStyle={'s5'} textTransform={'uppercase'}>{t('heading')}</Text>
			</Card.Header>
			<Card.Body py={12}>
				{children}
			</Card.Body>
			<Card.Footer>
				<Stack gap={2}>
					<Text textStyle={'s6'}>{t('acceptedPayment')}</Text>
					<HStack gap={4}>
						<NextImageWithSkeleton
							alt={'visa'}
							aspectRatio={'4/3'}
							objectFit={'contain'}
							src={'/visa.png'}
							width={'50px'}
						/>
						<NextImageWithSkeleton
							alt={'promptPay'}
							aspectRatio={'4/3'}
							objectFit={'contain'}
							src={'/promptPay.png'}
							width={'50px'}
						/>
					</HStack>
				</Stack>
			</Card.Footer>
		</Card.Root>
	);
};

export default CartSummaryCard;